import { E_RouterNames } from "@/router/types";

export interface IBuildBatteryAlarmHistoryRouterParams {
    companyId: number
    areaId: number
    equipmentId: number
    mappingId?: number
    sensorId?: string
    createTime?: string
}

export function buildBatteryAlarmHistoryRouter(params: IBuildBatteryAlarmHistoryRouterParams) {
    return {
        name: E_RouterNames.BatteryAlarmHistory,
        query: params
    }
}
